module.exports = __webpack_public_path__ + "img/BARCODE.21bdf0ec.svg";